import { render } from "./404.vue?vue&type=template&id=628bdbe0&lang=html"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=628bdbe0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__